<div class="mb-3">
  <div>
    <h1 class="pb-2 border-bottom fw-light" i18n>Verkäuferinformationen</h1>

    <!-- Render only once the data is in: isRetailer is undefined until then, so
         the account type would briefly read "Privater Anbieter". -->
    @if (customer) {
      <div class="row">
        <div class="col-lg-8">
          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>Name</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">{{ customer.fullName }}</label>
            </div>
          </div>

          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>Steuernummer</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">{{ customer.taxId }}</label>
            </div>
          </div>

          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>USt.-ID</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">{{ customer.vatRegNo }}</label>
            </div>
          </div>

          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>Kontoart</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">
                @if (customer.isRetailer) {
                  <ng-container i18n>Gewerblicher Anbieter</ng-container>
                } @else {
                  <ng-container i18n>Privater Anbieter</ng-container>
                }
              </label>
            </div>
          </div>

          <h2 class="pb-2 border-bottom mt-4" i18n>Anschrift</h2>

          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>Straße</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">{{ customer.street }}</label>
            </div>
          </div>

          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>PLZ</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">{{ customer.zipCode }}</label>
            </div>
          </div>

          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>Ort</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">{{ customer.city }}</label>
            </div>
          </div>

          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>Region</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">{{ customer.stateOrRegion }}</label>
            </div>
          </div>

          <h2 class="pb-2 border-bottom mt-4" i18n>Erreichbarkeit</h2>

          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>Telefon</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">{{ customer.phone }}</label>
            </div>
          </div>

          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>Fax</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">{{ customer.fax }}</label>
            </div>
          </div>

          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>E-Mail</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">{{ customer.email }}</label>
            </div>
          </div>

          <div class="row mb-2">
            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>Internet</label>
            <div class="col-sm-8">
              <label class="col-form-label col-form-label-sm">{{ customer.internet }}</label>
            </div>
          </div>
        </div>
      </div>

      <!-- The seller's own presence follows the regulatory details without a
           heading of its own (#103). d-block because the host is inline
           otherwise and mt-4 would not apply — with the heading gone, the row
           spacing alone (8px) is not enough of a separation. -->
      <app-custom-seller-info class="d-block mt-4" [CustomerId]="customer.id"></app-custom-seller-info>
    }

    <button class="btn btn-secondary mt-4" type="button" (click)="onBackClicked()" i18n>Zurück</button>
  </div>
</div>
